import { Box } from 'ui/Box';
import { FC, ChangeEvent } from 'react';
import { NextArrowButton } from '../NextArrowButton';
export interface InputFormProps {
  value: string;
  placeholder: string;
  disabled?: boolean;
  onSubmit: (text: string) => void;
  onInput: (event: ChangeEvent<HTMLInputElement>) => void;
}
export const InputForm: FC<InputFormProps> = ({
  value,
  placeholder,
  disabled = false,
  onSubmit,
  onInput,
}) => {
  return (
    <Box
      component="form"
      onSubmit={() => onSubmit(value)}
      className="mt-8 flex w-full max-w-[50rem] items-center rounded border border-solid border-mult bg-light"
    >
      <input
        className="h-full flex-1 bg-transparent p-4 outline-none"
        placeholder={placeholder}
        value={value}
        onChange={onInput}
      />
      <NextArrowButton disabled={disabled} />
    </Box>
  );
};
